import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Endpoint } from '@xanadu/model';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ImportService {
    private readonly http: HttpClient;

    constructor(
    ) {
        const handler = inject(HttpBackend);
        this.http = new HttpClient(handler);
    }

    public fetch(endpoint: Endpoint, parameters: { name: string, value: string }[], content: string): Observable<any> {
        let url: string = endpoint.data.url;
        if (parameters) {
            parameters.forEach(parameter => {
                const token = `[${parameter.name}]`;
                url = url.replace(token, parameter.value);
            });
        }
        let headers = new HttpHeaders();

        if (endpoint.data.headers instanceof Array) {
            const array = endpoint.data.headers as { key: string, value: string }[]
            array.forEach(header => headers = headers.set(header.key, header.value));
        }

        if (endpoint.data.contentType) {
            headers = headers.set('Content-Type', endpoint.data.contentType);
        }

        return this.http.request(endpoint.data.method, url, { body: content, headers });
    }
}
